"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.presentAutomationSafety = presentAutomationSafety;
function presentAutomationSafety(state, actions) {
    switch (state) {
        case 'DRAFT':
            return {
                severity: 'neutral',
                titleKey: 'com.streamlain.automation-safety.draft',
                enableAllowed: false,
            };
        case 'CANDIDATE_PENDING':
            return {
                severity: 'neutral',
                titleKey: 'com.streamlain.automation-safety.pending',
                enableAllowed: false,
            };
        case 'SAFE':
            return {
                severity: 'neutral',
                titleKey: 'com.streamlain.automation-safety.safe',
                enableAllowed: actions.includes('enable'),
            };
        case 'BLOCKED_CYCLE':
            return {
                severity: 'blocking',
                titleKey: 'com.streamlain.automation-safety.blocked',
                enableAllowed: false,
            };
        case 'EXTERNAL_UNVERIFIABLE':
            return {
                severity: 'warning',
                titleKey: 'com.streamlain.automation-safety.external',
                enableAllowed: actions.includes('enable'),
            };
        case 'ANALYSIS_FAILED':
            return {
                severity: 'blocking',
                titleKey: 'com.streamlain.automation-safety.failed',
                enableAllowed: false,
            };
        default: {
            const exhaustive = state;
            return exhaustive;
        }
    }
}
//# sourceMappingURL=safety-presentation.js.map